import {
	ISvgConfig,
	SvgTypeEnum
} from '@shared/components/svg/svg.model';

export function getSvgConfig( svgType: SvgTypeEnum ): ISvgConfig {
	switch ( svgType ) {
		case SvgTypeEnum.ACCOUNTS: {
			return {
				dimensions: {
					viewBoxWidth: 32.001,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.ACKNOWLEDGE:
		case SvgTypeEnum.ACTIVATIONS:
		case SvgTypeEnum.ARCHIVING: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.ARROW_DOWN:
		case SvgTypeEnum.ARROW_LEFT:
		case SvgTypeEnum.ARROW_RIGHT:
		case SvgTypeEnum.ARROW_UP: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.ASSIGN: {
			return {
				dimensions: {
					viewBoxWidth: 25,
					viewBoxHeight: 25
				}
			};
		}
		case SvgTypeEnum.AUTHORITIES_BADGE: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.BUSINESS_PREMISES: {
			return {
				dimensions: {
					viewBoxWidth: 32.434,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.CHECK: {
			return {
				dimensions: {
					viewBoxWidth: 10,
					viewBoxHeight: 9
				}
			};
		}
		case SvgTypeEnum.CHECKERED_FLAG: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.CHEVRON_LEFT:
		case SvgTypeEnum.CHEVRON_RIGHT: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.CLEAR:
		case SvgTypeEnum.COMPLAIN: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.CONTACT:
		case SvgTypeEnum.CONTRACT: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.DASHBOARD: {
			return {
				dimensions: {
					viewBoxWidth: 148,
					viewBoxHeight: 148
				}
			};
		}
		case SvgTypeEnum.DATACENTER: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.DECOMMISSION: {
			return {
				dimensions: {
					viewBoxWidth: 25,
					viewBoxHeight: 25
				}
			};
		}
		case SvgTypeEnum.DEFAULT: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.DETAILS: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.DOCUMENTATION: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.DOWNLOAD:
		case SvgTypeEnum.ELSTER_SUBMIT: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.ERROR: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.ERS: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.FILTER: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.IMPORT: {
			return {
				dimensions: {
					viewBoxWidth: 148.9,
					viewBoxHeight: 122.78
				}
			};
		}
		case SvgTypeEnum.KEYWORD: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.LICENCES: {
			return {
				dimensions: {
					viewBoxWidth: 149.57,
					viewBoxHeight: 137.59
				}
			};
		}
		case SvgTypeEnum.LOCKED: {
			return {
				dimensions: {
					viewBoxX: 14,
					viewBoxY: 7,
					viewBoxWidth: 40,
					viewBoxHeight: 51
				}
			};
		}
		case SvgTypeEnum.MAGNIFIER: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.MANAGE_TENANT: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.MANIFEST: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.MANIFEST_ASSIGN: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24.454
				}
			};
		}
		case SvgTypeEnum.MANUAL_EXPORT: {
			return {
				dimensions: {
					viewBoxWidth: 32.041,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.MESSAGE: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.MY_ACCOUNT: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.NO_ASSIGNMENT: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16,
				}
			};
		}
		case SvgTypeEnum.NO_ICON: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.NOTIFICATION_BELL: {
			return {
				dimensions: {
					viewBoxWidth: 20.194,
					viewBoxHeight: 23.605
				}
			};
		}
		case SvgTypeEnum.ORGANIZATION: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.PATCH: {
			return {
				dimensions: {
					viewBoxWidth: 28,
					viewBoxHeight: 28
				}
			};
		}
		case SvgTypeEnum.REACTIVATE: {
			return {
				dimensions: {
					width: 14,
					viewBoxWidth: 16,
					viewBoxHeight: 16.003
				}
			};
		}
		case SvgTypeEnum.RELOAD: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.RESET: {
			return {
				dimensions: {
					viewBoxWidth: 20.002,
					viewBoxHeight: 22.368
				}
			};
		}
		case SvgTypeEnum.RETURN: {
			return {
				dimensions: {
					viewBoxWidth: 25,
					viewBoxHeight: 25
				}
			};
		}
		case SvgTypeEnum.REVERT:
		case SvgTypeEnum.SIGNATURES:
		case SvgTypeEnum.SIGNATURE_PACKAGES:
		case SvgTypeEnum.STAR: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24,
				}
			};
		}
		case SvgTypeEnum.STATUS:
		case SvgTypeEnum.STRUCTURE: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.SUSPENDED: {
			return {
				dimensions: {
					viewBoxWidth: 16,
					viewBoxHeight: 16
				}
			};
		}
		case SvgTypeEnum.TENANTS: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32
				}
			};
		}
		case SvgTypeEnum.TSS_MODE_CLOUD: {
			return {
				dimensions: {
					viewBoxWidth: 32.014,
					viewBoxHeight: 32,
					width: 32,
					height: 32
				}
			};
		}
		case SvgTypeEnum.TSS_MODE_OFFLINE: {
			return {
				dimensions: {
					viewBoxWidth: 32.081,
					viewBoxHeight: 32,
					width: 32,
					height: 32
				}
			};
		}
		case SvgTypeEnum.TSS_MODE_TOKEN: {
			return {
				dimensions: {
					viewBoxWidth: 32,
					viewBoxHeight: 32,
					width: 30,
					height: 30
				}
			};
		}
		case SvgTypeEnum.UNLOCKED: {
			return {
				dimensions: {
					viewBoxX: 6,
					viewBoxY: 2,
					viewBoxWidth: 50,
					viewBoxHeight: 56
				}
			};
		}
		case SvgTypeEnum.UPLOAD: {
			return {
				dimensions: {
					viewBoxWidth: 24,
					viewBoxHeight: 24
				}
			};
		}
		case SvgTypeEnum.USAGE: {
			return {
				dimensions: {
					viewBoxWidth: 24.5,
					viewBoxHeight: 24,
				}
			};
		}
		case SvgTypeEnum.USERS: {
			return {
				dimensions: {
					viewBoxWidth: 148.98,
					viewBoxHeight: 136.15
				}
			};
		}
		default: {
			return {
				dimensions: {
					viewBoxHeight: 150,
					viewBoxWidth: 150
				}
			};
		}
	}
}
